import { mapState } from 'vuex';

export default {
  name: 'BigQ',

  data: () => {
    return {
      isCollapseBigQ: false,
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),

    //c_imgSrcBigQ() {
    //  let largeQ = '';
    //  if (this.ms_qaQuestion.source) {
    //    largeQ =
    //      '/img/questions/' +
    //      this.ms_qaQuestion.source.substr(0, 2) +
    //      '/' +
    //      this.ms_qaQuestion.source +
    //      '.question.png';
    //  }
    //  return largeQ;
    //},
  },

  methods: {
    toggleBigQ() {
      this.isCollapseBigQ = !this.isCollapseBigQ;
    },
  },
};
